var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['text-width-control', { active: _vm.active }],on:{"click":function($event){$event.preventDefault();return _vm.$emit('input', _vm.width)}}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }